<template lang="pug">
  modal-vue(
    :visible.sync="isVisible"
    modal_id="contract_form_modal"
    :content_loaded="true"
  )
    template(v-slot:header) {{ t('my_subscription.modal.title') }}
    template(v-slot:body)
      slot
        h4 {{ t('my_subscription.modal.form_title') }} {{ service }}
        div.alert.alert-info.my-3.p-2
          div.row.justify-content-center.align-items-center
            div.col-2.text-right
              i.fa.fa-lock.h2(aria-hidden="true")
            div.col-10.py-2
              span {{ t('my_subscription.modal.form_description') }}
        div.w-100(v-if="successfulRequest")
          p.message-success {{t('my_subscription.modal.confirmation')}}
        commercial-contact-form-vue(
          v-else,
          :app-source="service"
          @save_request:successful="handleSuccessfulRequest"
        )
    template(v-slot:footer)
      button#close.btn.btn-primary(@click="hide") {{ t('my_subscription.modal.close_button') }}
</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'subscriptions-contract-form-modal-vue',
  mixins: [ mixins.translate ],
  props: {
    initialService: { type: String, default: null }
  },
  components: {
    'modal-vue': () => import(/* webpackChunkName: "[request]" */ 'components/Modal'),
    'commercial-contact-form-vue': () => import(/* webpackChunkName: "[request]" */ 'components/CommercialContactForm'),
  },
  data() {
    return {
      isVisible: false,
      successfulRequest: false,
      service: ''
    }
  },
  methods: {
    show() { this.isVisible = true },
    hide() { this.isVisible = false },
    handleSuccessfulRequest() { this.successfulRequest = true }
  },
  mounted() {
    if (this.initialService) {
      this.service = this.initialService
      this.successfulRequest = false
      this.show()
    }

    this.$root.$on('open-contract-form-modal', (service) => {
      this.service = service
      this.successfulRequest = false
      this.show()
    })
  }
}
</script>
